import { FormField, FormHelper, FormInputGroup, FormLabel, TextArea } from '@vp/swan'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { RequiredIndicator } from '@shared/ui/form-label-indicators'
import type { IssueDescriptionFields } from '../../../config/issue-description-fields'
import { MAX_DESCRIPTION_LENGTH, MIN_DESCRIPTION_LENGTH } from '../../../config/issue-description-fields'

interface Props {
  control: Control<IssueDescriptionFields>
}

export const DescriptionField = ({ control }: Props) => {
  const { t } = useTranslation()
  return (
    <FormField data-testid="description-field">
      <FormLabel>
        {t('contact_us.page.steps.issue_description.description_label')}
        <RequiredIndicator />
      </FormLabel>
      <Controller
        name="description"
        control={control}
        rules={{
          required: true,
          minLength: MIN_DESCRIPTION_LENGTH,
          maxLength: MAX_DESCRIPTION_LENGTH,
        }}
        render={({ field }) => (
          <FormInputGroup>
            <TextArea
              data-testid="description-input"
              placeholder={t('contact_us.page.steps.issue_description.description_placeholder')}
              maxLength={MAX_DESCRIPTION_LENGTH}
              fullWidth
              style={{ resize: 'vertical' }}
              {...field}
            />
            <FormHelper data-testid="description-character-count">
              {t('contact_us.page.steps.issue_description.character_count', { count: field.value.length })}
            </FormHelper>
          </FormInputGroup>
        )}
      />
    </FormField>
  )
}
